import React from 'react'

import * as Styled from './AlternativeCollectionBox.styles'

const getAlternativeMessageTitle = messageKey => {
  let alternativeStoreTitle = 'Or get it quicker here:'

  if (messageKey === 'ALTERNATIVE_BETTER_SINGLE_SKU_PARTIAL_MESSAGE') {
    alternativeStoreTitle = "Or there's better availability here:"
  } else if (messageKey === 'ALTERNATIVE_BETTER_SINGLE_SKU_MESSAGE') {
    alternativeStoreTitle = "But here's where you can get it:"
  }
  return alternativeStoreTitle
}

export const AlternativeCollectionTitle = ({ alternativeStore }) => {
  const alternativeMessage =
    alternativeStore && alternativeStore.messageKey && getAlternativeMessageTitle(alternativeStore.messageKey)
  return (
    <Styled.AlternativeMessageTitle data-test='alternative-msg-title'>
      <strong>{alternativeMessage}</strong>
    </Styled.AlternativeMessageTitle>
  )
}
